import { Provider, useDispatch, useSelector } from "react-redux";
import "./App.css";
import store from "./store";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PatientDetails from "./pages/PatientDetails";
import Instruction from "./pages/Instruction";
import Login from "./pages/Login";
import Visits from "./pages/Visits";
import { URL } from "./utils/constant";
import FormSidebar from "./component/FormSidebar";
import Hypoglycemia from "./pages/CRF/Hypoglycemia/Hypoglycemia";
import BloodSugarRecord from "./pages/CRF/BloodSugarRecord/BloodSugarRecord";
import SavedRecords from "./pages/SavedRecords";
import Form from "./pages/CRF/Form";
import { LanguageChange } from "./Languages/Language";
import { useEffect } from "react";
import { getLanguageNumber } from "./data/selector/language.selector";
import BloodSugarRecordList from "./pages/CRF/BloodSugarRecord/BloodSugarRecordList";
import { getUserToken } from "./data/selector/appState.selector";
import { size } from "lodash";
import { useIdle } from "react-use";
import { setToken } from "./data/reducer/appState.reducer";
import { ToastContainer } from "react-toastify";
import Dialogue from "./component/shared/Dialogue";
import { useState } from "react";

function App() {
  const dispatch = useDispatch();
  const [Open, setOpen] = useState(false);
  const [Alert, setAlert] = useState("");
  const autologout = useIdle(1200000);

  useEffect(() => {
    if (autologout) {
      dispatch(setToken(""));
      setAlert("Session expired");
      setOpen(true);
    }
  }, [autologout]);

  return (
    <BrowserRouter>
      <main>
        <Dialogue open={Open} setOpen={setOpen} Alert={Alert} />
        <Routes>
          <Route path={URL.login} element={<Login />} />
          <Route path={URL.savedRecords} element={<BloodSugarRecordList />} />
          <Route path={URL.patientDetails} element={<PatientDetails />} />
          <Route path={URL.instruction} element={<Instruction />} />
          <Route path={URL.visit} element={<Visits />} />
          <Route path={URL.hypoglycemia} element={<Hypoglycemia />} />
          <Route path={URL.bloodsugarrecord} element={<BloodSugarRecord />} />
          <Route path={URL.form} element={<BloodSugarRecordList />} />
        </Routes>
      </main>
    </BrowserRouter>
  );
}

export default App;
